import react, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import HttpClient from '../../../../services/HttpClient'
import Button from '../../../../components/Button/Button'

export default function () {
  const navigate = useNavigate()
  const [errors, setErrors] = useState([])
  const [name, setName] = useState('')

  const onSubmit = async (event) => {
    event.preventDefault()
    setErrors([])

    if (!name) return setErrors(['Name is required'])

    try {
      const data = { name }
      await HttpClient().post('/api/v1/dashboard/characters/create/shogunato', data)
      navigate('/dashboard')
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        'Error creating shogunato. Endpoint may be missing on the server.'
      setErrors([msg])
    }
  }

  return (
    <div className="page">
      <div className="page__title">New shogunato</div>

      {errors.length > 0 && (
        <div className="form__errors">
          {errors.map((e, i) => (
            <div key={i} className="form__error">
              {e}
            </div>
          ))}
        </div>
      )}

      <form className="form" onSubmit={onSubmit}>
        <div className="form__group">
          <label className="form__label">Name</label>
          <input
            className="form__input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter shogunato name"
          />
        </div>
        <Button type="submit">Create</Button>
      </form>
    </div>
  )
}